import {PreviewCommentVo} from '../../common/shared/api/nicolas/vo/comment/PreviewCommentVo.interface';
import {PreviewComment} from '../generated/types';

export function createPreviewCommentItem({
  comment_uid,
  user_uid,
  user_name,
  user_thumbnail_url,
  comment: _comment,
  emoticon,
}: PreviewCommentVo): PreviewComment {
  return {
    commentUid: comment_uid,
    userUid: user_uid,
    userName: user_name,
    userThumbnailUrl: user_thumbnail_url,
    comment: emoticon ? _comment?.replace('(이모티콘)', '') : _comment,
    emoticon,
  };
}
